var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.073,
    height: 138.073,
    viewBox: "0 0 138.073 138.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12b7a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#128ca5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#12a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b7a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128ca5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2171",
    "data-name": "Trac\\xE9 2171",
    d: "M0,0H138.073V138.073H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2172",
    "data-name": "Trac\\xE9 2172",
    d: "M85.353,76.741a82.2,82.2,0,0,1-14.958-2.589L63.549,81A83.279,83.279,0,0,0,85.41,85.313V76.741ZM13.67,5H5.04A88.749,88.749,0,0,0,9.355,26.862l6.9-6.9A72.025,72.025,0,0,1,13.67,5Z",
    transform: "translate(23.955 23.765)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2173",
    "data-name": "Trac\\xE9 2173",
    d: "M100.8,106.555a5.77,5.77,0,0,0,5.753-5.753V80.724a5.77,5.77,0,0,0-5.753-5.753,65.625,65.625,0,0,1-20.538-3.279A4.83,4.83,0,0,0,78.48,71.4,5.893,5.893,0,0,0,74.4,73.072L61.739,85.729A87.151,87.151,0,0,1,23.826,47.816L36.483,35.16a5.774,5.774,0,0,0,1.438-5.868A65.357,65.357,0,0,1,34.642,8.753,5.77,5.77,0,0,0,28.889,3H8.753A5.77,5.77,0,0,0,3,8.753,97.793,97.793,0,0,0,100.8,106.555Zm-20.711-22.9a73.366,73.366,0,0,0,14.958,2.589v8.572A88.75,88.75,0,0,1,73.187,90.5ZM14.679,14.506h8.63a74.79,74.79,0,0,0,2.646,14.9l-6.9,6.9a85.292,85.292,0,0,1-4.372-21.8Z",
    transform: "translate(14.259 14.259)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.0593f7ba.svg";
export { ForwardRef as ReactComponent };